/**
 * Created by m.igrachev on 8/4/2017.
 */
const documentedProperties = [
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to OutputText container."
    },
    {
        name: "text",
        type: "String",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Text with placeholders $"
    },
    {
        name: "alignment",
        type: "['left', 'right', 'center', 'justify']",
        defaultValue: "left",
        isRequired: "true",
        description: "Defines the Paragraph content alignment."
    }
];

export default documentedProperties;
